export default __webpack_public_path__ + "static/media/Shadow's Bane.ee6080e8.jpg";